<template lang="pug">
.send-password-reset
    .send-password-reset__form(v-if="!sent")
        el-form(:model="form", :rules="rules")
            el-form-item(label='Email address', prop="email")
                el-input(type="email", v-model="form.email")
            el-button(type="primary", @click="sendPasswordReset", :loading="loading") Send Password Reset Email
    .send-password-reset__success(v-else)
        h2 Success!
        p Please check your email for instructions and a magic link to reset your account password.
    router-link(:to="{name: 'auth.login'}")
        el-button.send-password-reset__return(type='text') < Return to login
</template>

<script>
import gql from "graphql-tag";

export default {
	data() {
		return {
			sent: false,
			loading: false,
			form: {
				email: ""
			},
			rules: {
				email: [{ required: true, trigger: "blur" }]
			}
		};
	},

	created() {
		if (this.$route.query.email) {
			this.form.email = this.$route.query.email;
		}
	},

	methods: {
		async sendPasswordReset() {
			this.loading = true;

			try {
				await this.$apollo.mutate({
					client: "public",
					mutation: gql`
						mutation SendPasswordResetEmail($email: String!) {
							SendPasswordResetEmail(email: $email)
						}
					`,
					variables: {
						email: this.form.email
					}
				});
				window.Intercom("trackEvent", "request-password-reset");
				this.$message.success(`Password reset instructions sent to ${this.form.email}`);
				this.sent = true;
			} catch (error) {
				console.error("Error", error);
				this.$message.error("Failed");
			} finally {
				this.loading = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.send-password-reset {
	&__return {
		padding-top: 40px;
	}
}
</style>
